// FIXME: we apply too much from sx as allowed in our shared library
import { Paper, Stack } from '@mui/material'
import { type ModalInjectedByMui, type ModalProps } from './types'

export const ModalBase = ({
  children,
  dividers,
  open,
  width,
  maxWidth,
  height,
  maxHeight = '100%',
  keepMounted = false,

  // START deconstructing because we do not want them to drill to paper
  // MUI Modal clones its children to add tabIndex, so we can not use styled component with `shouldForwardProp`
  'data-testid': _dataTestId,
  disableAutoFocus,
  disableRestoreFocus,
  tabIndex,
  // END deconstructing because we do not want them to drill to paper

  ...props
}: ModalProps & ModalInjectedByMui) => {
  const hasDividerTop = dividers?.some((d) => d === 'top')
  const hasDividerBottom = dividers?.some((d) => d === 'bottom')

  // Prevent unneeded code to be executed and keeping behavious same for our Modal since for
  // mobile variant it uses the SwipeableDrawer.
  if (!open && !keepMounted) {
    return null
  }

  return (
    <Paper
      className="DhlModal-paper"
      tabIndex={-1}
      {...props}
      sx={{
        '&&': {
          height,
          maxHeight,
          width: maxWidth && !width ? maxWidth : width,
          maxWidth: !maxWidth && width ? width : maxWidth,
          boxShadow: 'none',
          display: 'flex',
          padding: 0,
          flex: '0 1 auto',
          overflow: 'auto',
        },
      }}
    >
      <Stack
        className={[
          'DhlModal-base',
          ...(hasDividerTop ? ['DhlModal-dividers-top'] : []),
          ...(hasDividerBottom ? ['DhlModal-dividers-bottom'] : []),
        ].join(' ')}
        sx={{ flex: '1', display: 'flex', flexDirection: 'column', minWidth: 0 }}
      >
        {children}
      </Stack>
    </Paper>
  )
}
